import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {resolveSkeletonBrickTheme} from '@Components/ai-chat-window/lib/skeleton.library';
import type {EntityDraftSkeletonProps} from './entity-draft-skeleton.types';
import styles from './entity-draft-skeleton.module.scss';

/**
 * Transient placeholder mirroring the entity-draft-card layout, shown while the
 * agent is still composing the draft. Replaced automatically by the streamed
 * intro text / real draft card (it renders as a thinking message).
 */
export function EntityDraftSkeleton({mode}: EntityDraftSkeletonProps): ReactElement {
  const theme = resolveSkeletonBrickTheme(mode);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <SkeletonBrick width={'60%'} height={14} radius={'4px'} theme={theme} />
        <SkeletonBrick width={56} height={20} radius={'999px'} theme={theme} />
      </div>
      <div className={styles.divider} />
      <SkeletonBrick width={'100%'} height={14} radius={'4px'} theme={theme} />
      <SkeletonBrick width={'75%'} height={14} radius={'4px'} theme={theme} />
      <SkeletonBrick width={'100%'} height={240} radius={'12px'} theme={theme} />
    </div>
  );
}
